import { Storage } from "../util"

const state = {
    usuario: null,
}

const actions = {
    setUsuario(store, usuario) {
        store.commit("setUsuario", usuario)
        Storage.setObject("usuario", usuario)
    },
    removeUsuario(store) {
        store.commit("setUsuario", null)
    },
    loadUsuario(store) {
        store.commit("setUsuario", Storage.getObject("usuario"))
    }
}

const mutations = {
    setUsuario(state, usuario) {
        state.usuario = usuario
    }
}

const getters = {
    usuario: state => {
        return state.usuario
    }
}

export const UsuarioStore = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}